import { Handshake, ShoppingCart, Compass, CarFront, Package, Store, Sparkles, GraduationCap, Trophy, Droplets } from "lucide-react";
import { useLang } from "@/App";
import { all, pick } from "@/data/images";
import Hero from "@/components/Hero";
import { Reveal, Pretitulo } from "@/components/Reveal";

const ICONOS = [Handshake, ShoppingCart, Compass, CarFront, Package, Store, Sparkles, GraduationCap, Trophy, Droplets];

export default function Comunidad() {
  const { t } = useLang();
  const p = t.comunidad;
  return (
    <div data-testid="pagina-comunidad">
      <Hero pre={p.hero.pre} titulo={p.hero.titulo} fotos={[pick(p.hero.foto[0], 0) || all(p.hero.foto[0])[0]]} testid="hero-comunidad" alto="h-[58vh] min-h-[440px] md:h-[72vh]" foco="80% 15%" />

      <section className="py-20 md:py-28" data-testid="co-intro">
        <div className="mx-auto max-w-3xl px-6 text-center md:px-10">
          <Reveal>
            <Pretitulo>{p.pre}</Pretitulo>
            <h2 className="mt-4 font-serif text-3xl font-light tracking-tight text-ink md:text-5xl">{p.titulo}</h2>
            <p className="mt-7 text-left text-[15.5px] leading-relaxed text-ink-soft md:text-center">{p.cuerpo}</p>
          </Reveal>
        </div>
      </section>

      <section className="pb-20 md:pb-28" data-testid="co-acciones">
        <div className="mx-auto max-w-[1300px] px-6 md:px-10">
          <div className="grid gap-5 sm:grid-cols-2 lg:grid-cols-5 md:gap-6">
            {p.acciones.map((a, i) => {
              const Icono = ICONOS[i] || Handshake;
              return (
                <Reveal key={a.t} delay={(i % 5) * 0.06} className="border border-lineas bg-sand p-6" testid={`co-accion-${i + 1}`}>
                  <Icono size={24} strokeWidth={1.3} className="text-terra" />
                  <h3 className="mt-4 font-serif text-lg text-ink">{a.t}</h3>
                  <p className="mt-2 text-[13px] leading-relaxed text-ink-soft">{a.d}</p>
                </Reveal>
              );
            })}
          </div>
        </div>
      </section>
    </div>
  );
}